<template>
  <div>
    <ValidationObserver ref="observer">
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>General</v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Date"
                  >
                    <datePickComponent
                      labelname="Date"
                      v-model="sale.date"
                      @input="updateDate(sale.date)"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                  <v-text-field
                    v-if="saleQuotation"
                    v-model="saleDetails.searchCustomer"
                    hide-details="auto"
                    disabled
                    outlined
                    label="Customer"
                  ></v-text-field>

                  <ValidationProvider
                    v-if="!saleQuotation"
                    name="Customer"
                    rules="required"
                    vid="name"
                  >
                    <v-autocomplete
                      v-if="!saleQuotation"
                      hide-details="auto"
                      slot-scope="{ errors }"
                      v-model="sale.customer_id"
                      item-text="name"
                      item-value="id"
                      outlined
                      :search-input.sync="searchCustomer"
                      :items="customerDatas"
                      label="Customer"
                      :error-messages="errors"
                    >
                      <template v-slot:item="{ item, attrs, on }">
                        <v-list-item
                          v-bind="attrs"
                          v-on="on"
                          @click="setCustomerDatas($event, item)"
                        >
                          <v-list-item-title
                            :id="attrs['aria-labelledby']"
                            v-text="item.name"
                          ></v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                  <v-text-field
                    v-if="saleQuotation"
                    v-model="saleDetails.searchShop"
                    hide-details="auto"
                    disabled
                    outlined
                    label="Shop"
                  ></v-text-field>
                  <ValidationProvider
                    name="Shop"
                    rules="required"
                    vid="name"
                    v-if="!saleQuotation"
                  >
                    <v-autocomplete
                      v-if="!saleQuotation"
                      hide-details="auto"
                      slot-scope="{ errors }"
                      v-model="sale.shop_id"
                      @change="updateShop(sale.shop_id)"
                      :search-input.sync="searchShop"
                      item-text="name"
                      item-value="id"
                      outlined
                      :items="ShopDatas"
                      label="Shop"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>
<script>
import { required } from 'vee-validate/dist/rules';
import datePickComponent from '@/components/base/DateComponent';
import { CustomerViewModel } from '../../models/View Models/CustomerViewModel';
import { mapState } from 'vuex';

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

extend('required', {
  ...required,
  message: '{_field_} is required',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
  },
  computed: {
    ...mapState(['saleQuotation']),
    ...mapState(['saleDetails']),
  },

  created() {
    this.GetCustomerDatas();
    this.GetShopDetails();
  },

  methods: {
    updateDate(value) {
      this.$emit('setDate', value);
    },
    setCustomerDatas(newvalue, value) {
      this.$emit('setCustomer', value.id);
    },
    updateShop(value) {
      this.$emit('setShop', value);
    },
    GetShopDetails() {
      this.$store
        .dispatch('shop/GetAllShopsDetails', {})
        .then((res) => {
          this.ShopDatas = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },

    getShopByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('shop/GetShop', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.ShopDatas = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    getCustomersByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('customer/GetCustomerSearch', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.customerDatas = res.map((u, i, arr) => {
            u.index = i + 1;
            return new CustomerViewModel(u);
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    GetCustomerDatas() {
      this.$store
        .dispatch('customer/GetCustomers')
        .then((res) => {
          this.customerDatas = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  props: {
    sale: {
      type: Object,
      default: {},
    },
  },
  watch: {
    searchCustomer(value) {
      if (value != 'Walk-in customer') {
        this.getCustomersByQuery(value);
      }
    },
    searchShop(value) {
      if (value != 'Default') {
        this.getCustomersByQuery(value);
      }
    },
  },
  data: () => ({
    customerDatas: [],
    ShopDatas: [],
    searchCustomer: null,

    searchShop: null,
    // sale: {},
    messages: [],
  }),
};
</script>
